import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import {
  FormItem,
  type ErrorMessageType,
} from "@freightsimple/ui-core/FormLayout/FormItem";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { EquipmentType } from "@freightsimple/generated-dashboard-openapi-client/models/EquipmentType";

interface EquipmentTypeDropdownProps {
  equipmentType: EquipmentType | undefined;
  onEquipmentTypeChange: (newValue: EquipmentType | undefined) => void;
  enabled: boolean;
  errorMessage?: ErrorMessageType | undefined;
  forceValidation?: boolean | undefined;
}

function describeEquipmentType(value: EquipmentType): string {
  switch (value) {
    case EquipmentType.DryVan:
      return "Dry Van";
    case EquipmentType.FlatBed:
      return "Flatbed";
    case EquipmentType.Reefer:
      return "Temperature Controlled / Reefer";
  }
}

const options = Object.values(EquipmentType).map((value) => ({
  value,
  label: describeEquipmentType(value),
}));

export function BookShipmentEquipmentTypeDropdown(
  props: EquipmentTypeDropdownProps,
) {
  return (
    <ShowFormErrors show={props.forceValidation ?? false}>
      <FormItem error={props.errorMessage} fillWidth>
        <Dropdown
          value={props.equipmentType}
          onChange={(v) => props.onEquipmentTypeChange(v as EquipmentType)}
          options={options}
          placeholder="Please Select"
          disabled={!props.enabled}
          width="full"
        />
      </FormItem>
    </ShowFormErrors>
  );
}
